module.exports = __webpack_public_path__ + "img/open-menu.852e0234.svg";